
import layerEvents from "../utils/layerEvents";
import { Button, Col, Row, Dropdown, Form, Container} from "react-bootstrap";
import { hydrateRoot } from 'react-dom/client';
import Select from "react-select";
import { PencilSimple,Lightning, Windmill, BatteryCharging, BatteryFull, Spiral, Ruler, Crosshair, X, Info, Eye, Trash, DotsThreeVertical, Wind, Calculator, Warning, CircleNotch, Plus,ArrowUp, Pencil,CrosshairSimple   } from "@phosphor-icons/react";
import DataTable from 'react-data-table-component';
import vindrApi from "../utils/vindrapi";
import {formatDate, generateId, isNumeric} from "../utils/functions";
import EditNow from "../components/EditNow";
import QuickAnnotation from "../components/QuickAnnotation";
import DoNowButton from "../components/DoNowButton";
import ReactDOM from "react-dom/client";
import clickableMarker from "../utils/clickableMarker";
import LayerAnnotation from "../classes/LayerAnnotation";
import * as yup from 'yup';
import * as formik from 'formik';
import schemas from "../data/dataSchemas";
import * as React from 'react';
import Tool						from "../classes/Tool";
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax



const { Formik } = formik;

class ToolAnnotation extends Tool {

	tabIndex			= null;
	highlightedOnList	= [];
	currentAnnotation	= null;
	popups				= [];
	
	modified			= false;
	
	ADD					= 1;
	REMOVE				= 2;
	
	_noteIconSize		= {x:30,y:30};

	type				= 'annotation';
	itemsName			= 'annotations';
	id					= 'annotationid';
	infolayerId			= 'annotations';
	
	constructor(p) {
		super();
		if(p){
			this.tc = p;
			this.parent = p;
		}
		if (!ToolAnnotation.annotations){
			ToolAnnotation.annotations		= [];
			ToolAnnotation.tabIndex		= null;
		}
		this.canvas = this.parent.map.getCanvasContainer();
		this.getHiddenItems();
	}
	getToolLayer() {
		return LayerAnnotation;
	}
	setCursor(cur){
		this.parent.map.getContainer().classList.add(cur);
		return this;
	}
	remCursor(cur){
		this.parent.map.getContainer().classList.remove(cur);
		return this;
	}
	markerId(id){
		return 'annotation-marker'+id;
	}
	setAddAnnotationListener = ()=>{
		this.parent.map.getContainer().classList.add("cursor-add-annotation");
		this.parent.map.on('click', this.addAnnotation);
	}
	remAddAnnotationListener = ()=>{
		this.parent.map.getContainer().classList.remove("cursor-add-annotation");
		this.parent.map.off('click', this.addAnnotation);
	}
	addOutsideClickListener = ()=>{
		this.parent.map.on('click', this.handleClickOutside);
	}
	remOutsideClickListener = ()=>{
		this.parent.map.off('click', this.handleClickOutside);
	}
	update(){
		

	}
	init(){
		this.display();
		this.setEventHandlers();
	}
	exit(){
		if(this.parent.serviceBar.current)
			this.parent.serviceBar.current.clear(ToolAnnotation.tabIndex);
		ToolAnnotation.tabIndex = null;
		this.removeEventHandlers();
		this.closePopups(true);
	}
	setEventHandlers(){

		if(!this.parent)
			return;

		this.setAddAnnotationListener();
		this.parent.map.on('contextmenu', this.handleRightClick);
		this.setInOutListeners();
		this.parent.map.on('mousedown', LayerAnnotation.layerId, this.onDown);
	}
	removeEventHandlers(){
		if(!this.parent)
			return;

		this.parent.map.off('contextmenu', this.handleRightClick);
		this.parent.map.off('click', this.removeAnnotation);
		this.parent.map.off('click', this.addAnnotation);
		this.remOutsideClickListener();
		this.remAddAnnotationListener();
		this.unsetInOutListeners();
		this.parent.map.off('mousedown', LayerAnnotation.layerId, this.onDown);
		this.parent.map.getContainer().classList.remove("cursor-add-annotation");
	}
	setInOutListeners(){
		this.parent.map.on('mouseenter', LayerAnnotation.layerId, this.onEnter);
		this.parent.map.on('mouseleave', LayerAnnotation.layerId, this.onLeave);
	}
	unsetInOutListeners(){
		this.parent.map.off('mouseenter', LayerAnnotation.layerId, this.onEnter);
		this.parent.map.off('mouseleave', LayerAnnotation.layerId, this.onLeave);
	}
	onDown = (e) => {
		if(e.originalEvent.which != 1)
			return;
		const features = this.getPointFeatures(e);
		if(!features[0])
			return;
		const annotationId = features[0].properties.annotationid ?? features[0].properties.tempid;
		const marker = ToolAnnotation.annotations.find(m => m._element.dataset.annotationid == annotationId);


		e.preventDefault();
		
		this.unsetInOutListeners();
		this.currentAnnotationId	= annotationId;
		this.currentAnnotationIdx	= features[0].properties.idx;
		
		this.setCursor('cursor-grabbing');
		
		this.parent.map.mouseDown = true;
		this.parent.map.on('mousemove', this.onMove);
		this.parent.map.once('mouseup', this.onUp);
	}
	onMove = (e) => {
		const coords = e.lngLat;
		this._dragging = true;
		this.canvas.style.cursor = 'grabbing';
		this.updateMapFeatCoordinates(this.currentAnnotationId, [coords.lng, coords.lat]);
		
		this.currentAnnotationMarker?.setLngLat(coords);
		this.popups[this.currentAnnotationId]?.setLngLat(coords);
	}
	onUp = (e) => {
		if(e.originalEvent.which != 1)
			return;
		const coords = e.lngLat;
		this.setInOutListeners();
		this.remCursor('cursor-grabbing');
		
		
		if(this._dragging && this.currentAnnotationId){
			const an = this.parent.scenario.annotations.find(a => a.id == this.currentAnnotationId);
			if(an){
				an.lat = coords.lat;
				an.lon = coords.lng;
				this.save(vindrApi.updateAnnotations(this.parent.scenario.projectid, this.parent.scenario.scenario_id, an));
			}
			//this.resetLayer();
		}
		if(!this._dragging && this.currentAnnotationId !== null && !this.popups[this.currentAnnotationId]){
			this.handleAnnotationClick(e);
		}
		
		this.currentAnnotationId	= null;
		this.currentAnnotationIdx	= null;
		this.currentAnnotationMarker = null;
		delete this._dragging
		delete this.parent.map.mouseDown;
		this.parent.map.off('mousemove', this.onMove);
	}
	onEnter = (e) => {
		
		const fId = this.getPointFeatures(e)[0]?.id;
		
		if(fId !== null)
			this.highlightOnList(fId);
		
		this.remCursor("cursor-add-annotation").setCursor("cursor-pointer");
	}
	onLeave = (e) => {

		

		this.deHighlightOnList(0);
		
		this.remCursor("cursor-pointer").setCursor("cursor-add-annotation");
	}
	addAnnotation = (e)=>{
		if(this.parent.secondaryHandler)
			return;
		
		const features = this.getPointFeatures(e);
		if(this._dragging){
			delete this._dragging;
			return;
		}
		
		if(features.length)
			return;
		
		this.closeContextMenu();
		
		
		e.originalEvent.stopPropagation();
		
		var newAnnotation = {
			"id":0,
			"lon": e.lngLat.lng,
			"lat": e.lngLat.lat,
			"project_id": this.parent.scenario.projectid,
			"scenario_id": this.parent.scenario.scenario_id,
			"type": "note",
			"text": "",
			"timestamp": (new Date()).toISOString()
		}
		
		this.tc.scenario.annotations.push(newAnnotation);
		
		const f = LayerAnnotation.itemToFeature(newAnnotation, this.tc.scenario.annotations.length-1);
		
		this.addFeature(f);	
		this.openPopup(newAnnotation);
	}

	removeAnnotation = (annotation) =>{
		
		var	annotationId = annotation.id;
		

		if(annotationId == null)
			return
		
		var an = this.parent.scenario.annotations.find((a)=>{return a.id == annotationId});
		
		if(an && an.id > 0){
			this.save(
				vindrApi.deleteAnnotations(an.project_id, an.scenario_id, an.id).then((res)=>{

					const idx = this.parent.scenario.annotations.find((a)=>{return a.id == annotationId});
					var newScenario = structuredClone(this.parent.scenario);
					newScenario.annotations.splice(idx, 1);
					this.parent.setScenario(newScenario);

					this.delAnnotation(annotationId);
				})
			);
		}
		else{
			this.delAnnotation(annotationId);
		}
		
		this.display();
	}
	delAnnotation(id){
		
		var idx = this.parent.scenario.annotations.findIndex((a)=>{return a.id == id});
		
		if(idx == -1)
			return;
		
		this.parent.scenario.annotations.splice(idx, 1);
		this.deleteFeature("annotationid", id);
	}

	addAnnotationText(annotation, onFinish, edit){

		return (
	
				<QuickAnnotation context={this.parent.draw.context} edit={edit} annotation={annotation} onFinish={onFinish ? onFinish : null}  />
			
		);
		
	}
	addAnnotationTextWrp(annotationid){
		
		var input = document.createElement('div');
		input.className = "annotation-text-wrp";
		return input;
		
	}

	handleKeyPress = (e)=>{
		e.stopPropagation();
	}

	
	handleAnnotationClick = (e)=>{

		if(this._dragging){
			delete this._dragging;
			return;
		}
		
		const an = this.tc.scenario.annotations[this.currentAnnotationIdx];

		this.openPopup(an);
	}
	
	openPopup(an, edit = false){
		
		if(!this._expandingAll)
			this.closePopups();
		
		const popup = new mapboxgl.Popup({
			closeButton: false,
			closeOnClick: false,
			anchor:'left',
			offset:[40, 0],
			className:"annotation-popup"
		});
		// Populate the popup and set its coordinates based on the feature found.
		popup.setLngLat([an.lon, an.lat]).setHTML('<div id="annotation_'+an.id+'" class="annotation-text-wrp"></div>').addTo(this.tc.map);


		ReactDOM.createRoot(document.getElementById("annotation_"+an.id)).render(this.addAnnotationText(an, ()=>{
			
			this.display();
		}, edit));
	
		if(!this._expandingAll)
			this.addOutsideClickListener();
		this.remAddAnnotationListener();
		this.popups[an.id] = popup;


	}
	closePopups(){
		this.popups.forEach((v,k)=>{
			
			if(k === 0){
				this.delAnnotation(k);
			}
			
			v.remove();
			delete this.popups[k];
		})
		this.remOutsideClickListener();
		this.setAddAnnotationListener();
	}

	handleClickOutside = (e)=>{
		
		const features = this.getPointFeatures(e);
		
		//probably catching a mouseup event when opening
		if(features.length)
			return;
		
		this.closePopups();
	}
	highlightOnMap = (row) => {
		this.updateMapFeatPop("annotationid", row.id, {"hover": true});
	}

	deHighlightOnMap = (row) => {
		this.updateMapFeatPop("annotationid", row.id, {"hover": false});
	}
	
	idString(id){
		return isNaN(id) ? id : id.toString();
	}
	
	highlightOnList = (id) => {
		this.highlightedOnList.push(this.idString(id));
		
		this.highlightedOnList = [...new Set(this.highlightedOnList)];

		this.display();
	}
	deHighlightOnList = (id) => {

		this.highlightedOnList = [];
		
		this.display();
	}
	
	
	handleRowClick = (row)=>{
		
		this.handleEditAnnotation(row);
	}
	setHideAll(value){
		this.allHidden = value;
		this.display();
	}
	
	addMapClickClose(){
		
		document.addEventListener("click", this.closeContextMenu);
	}
	handleExpandAll = (e) => {

		const show = e.target.checked;
		
			if(!show)
				return this.closePopups();
		
		this._expandingAll = true;

		this.tc.scenario.annotations.forEach((m)=>{
			if(!this.popups[m.id])
				this.openPopup(m);
		});
		this.addOutsideClickListener();
		this._expandingAll = false;
	}
	
	getHiddenItems(){
		this.hiddenItems = this.tc.scenario.annotations
			.filter(a => a.invisible ?? a?.properties?.invisible)
			.map(a => a.id);
	}
	handleHideAllItems = () => {
		if(!this.areAllHidden())
			this.closePopups();
		Tool.prototype.handleHideAllItems.call(this);
		this.display();
	}
	handleToggleItem = (e, item_id, f, dontRefresh) => {
		e?.stopPropagation();
		this.toggleItem(item_id, f, dontRefresh, (id, force, hide) => {
			if(hide) this.popups[id]?.remove();
		});
		if(!dontRefresh) this.display();
	}

	handleRemoveAnnotation = (annotation) => {
		this.removeAnnotation(annotation);
		this.display();
		return true;
	}
	handleSelect = (e, row) => {
		const id = "id";
		if(!this.selected)
			this.selected = [];
		const idx = this.selected.findIndex((a)=>{return a[id] == row[id]});
		if(idx !== -1){
			this.selected.splice(idx, 1);
		}
		else{
			this.selected.push(row);
		}
		this.display();
	}
	handleSelectAll = () => {
		if (!this.selected) this.selected = [];
		const items = (this.parent.scenario.annotations ?? []).filter(a => !!a.text);
		const allSelected = items.length > 0 && items.every(d => this.selected.some(s => s.id === d.id));
		if (allSelected) { this.selected = []; } else { this.selected = items.slice(); }
		this.display();
	}
	handleBulkDelete = () => {
		if(!this.selected || !this.selected.length)
			return;
		this.selected.forEach((row) => {
			this.removeAnnotation(row);
		});
		this.selected = [];
		this.display();
	}

	handleEditAnnotation(annotation){
		
		
		this.openPopup(annotation, true);
	}
	handleZoomAnnotation = (an)=>{

		this.parent.map.resize(); //if we don't do this sometimes there will be offset in the the center
		this.parent.map.flyTo({
			center:[an.lon, an.lat] ,
			speed: 1.2,
			zoom: 14
		});


	}

	isSelectedOnList = (row)=>{
		return this.highlightedOnList.includes(this.idString(row.id));
	}
	isAllShowing= () => {
		
		var res = true;
		ToolAnnotation.annotations.forEach((m)=>{
			if(!m._element.classList.contains('active'))
				res	= false;
		});
		return res;
	}
	setExpandToggle(val){
		if(document.getElementById('expand-all'))
			document.getElementById('expand-all').checked = val;
	}
	display(){
		if(this.parent.serviceBar.current)
			ToolAnnotation.tabIndex =	this.parent.serviceBar.current.inject(this.render(), ToolAnnotation.tabIndex);
	}
	closeContextMenu = ()=>{
		
		
		document.removeEventListener("click", this.closeContextMenu);
		
		if(!this.parent)
			return;
		var a = false;
		if(a = this.parent.map.getContainer().querySelector(".annotationModeContextMenu")){
			a.remove();
		}
		
		
	}
	handleRightClick = (e)=>{
		e.originalEvent.preventDefault();
		const features = this.getPointFeatures(e);
		if(!features.length)
			return;
		
		
		const an = this.parent.scenario.annotations.find((a)=>{return a.id == features[0].id});

		var wrp = document.createElement("div");
		wrp.className = "annotationModeContextMenu";
		wrp.style.left = e.point.x+'px';
		wrp.style.top = e.point.y+'px';

		this.closeContextMenu();
		this.parent.map.getContainer().appendChild(wrp);
		this.addMapClickClose();
		ReactDOM.createRoot(wrp).render(this.contextMenu(an));
	}
	contextMenuEdit(annotation){
		return (
			<button className="btn" onClick={(e)=>{this.handleEditAnnotation(annotation); this.closeContextMenu();}}><Plus size={20} /> Edit Annotation</button>
		);
	}
	contextMenu(annotation){
		return (
			<>
				<button className="btn" onClick={(e)=>{this.handleEditAnnotation(annotation); this.closeContextMenu();}}><Pencil size={20} /> Edit annotation</button>
				<button className="btn" onClick={(e)=>{this.handleZoomAnnotation(annotation); this.closeContextMenu();}}><CrosshairSimple  size={20} /> Zoom to annotation</button>
				<button className="btn" onClick={(e)=>{this.removeAnnotation(annotation); this.closeContextMenu();}}><Trash size={20} /> Remove annotation</button>
			</>
		);
	}
		
	render(){
		
		//this.allHidden = this.parent.map.getContainer().classList.contains("hide-annotations");
		
		var annotations = this.parent.scenario.annotations ? this.parent.scenario.annotations.filter((a)=>{return !!a.text}) : [];
		return (
			<>
				<div className={"project-annotations "}>
					<div className="title">
						Annotations
						{/*<span onClick={(e)=>{this.parent.exit()}} 	className="btn btn-close alt float-end"><X size={16} /></span>*/}
					</div>
					<div className="scroll">
						<div className="content p-0">

							<DataTable
								data={annotations}
								columns={
									[
										{
											name:<Eye onClick={this.handleHideAllItems} className={""+(this.areAllHidden() ? 'opacity-25' : '')} size={16} />,
											id:'userid',
											selector: row => row.userid,
											format: (row) =>	(<Eye onClick={(e)=>{this.handleToggleItem(e, row.id, undefined, false)}} id={"bndr_"+row.id} data-id={row.id}  className={""+(this.hiddenItems.includes(row.id) || this.areAllHidden() ? 'opacity-25' : '')} size={16} />),
											style: {
												padding: '0',
												maxWidth:"28px !important",
											}
										},
										{
											name:(
												<Form.Check
													type="checkbox"
													checked={!!(this.parent.scenario.annotations?.filter(a=>!!a.text).length) && this.parent.scenario.annotations.filter(a=>!!a.text).every(d => this.selected && this.selected.some(s => s.id === d.id))}
													ref={el => { if (el) el.indeterminate = !!(this.selected?.length) && this.selected.length < (this.parent.scenario.annotations?.filter(a=>!!a.text).length ?? 0); }}
													onChange={this.handleSelectAll}
												/>
											),
											selector: row => row.text,
											format: (row,index) => ( <label className="checkbox-pad"><Form.Check type="checkbox" id={"check-"+row.id} checked={this.selected && this.selected.some((a)=>a.id == row.id)} onClick={(e)=>{this.handleSelect(e, row);}} /></label>),
											width:"25px",
											style: {
												padding: '0px !important',
												width:'25px'
											}
										},
										{
											name:'Annotation',
											selector: (row) => (row.text),
											format: (row,index) => (row.text),
											sortable:true,
											width:"195px",
											//maxWidth:"160px !important",
										},
										{
											name:'Date',
											selector: (row) => {return row.timestamp},
											format: (row,index) => (formatDate(row.timestamp, 'short')),
											sortable:true,
											width:"80px",
											center: "true",
											//maxWidth:"160px !important",
										},
										{
											name:'',
											cell: row => (
												<div className="context-menu" data-tag="allowRowEvents">
														<Dropdown className="minimal">
															<Dropdown.Toggle className="p-0 px-1" variant="default">
																<DotsThreeVertical size={16} />
															</Dropdown.Toggle>
															<Dropdown.Menu>
																<Dropdown.Item href="#" onClick={(e)=>{ this.handleEditAnnotation(row);   }}><PencilSimple size={16} /> Edit annotation</Dropdown.Item>
																<Dropdown.Item href="#" onClick={(e)=>{this.handleZoomAnnotation(row);}}><CrosshairSimple  size={16} /> Zoom to annotation</Dropdown.Item>
																<Dropdown.Item href="#" onClick={(e)=>{ this.handleRemoveAnnotation(row); }} className="text-danger" ><Trash size={16} /> Remove annotation</Dropdown.Item>
															</Dropdown.Menu>
														</Dropdown>
												</div>
											),
											style: {
												maxWidth:"20px !important"
											}
											
											//minWidth:"160px !important",
											//maxWidth:"160px !important",
										}
									]
								}
								customStyles={{
									headCells:{
										style: {
											padding:'.5rem .3rem',
											minWidth:'0px !important',
											boxSizing:'content-box',
											fontWeight:'bold'
										}
									},
									cells:{
										style: {
											padding:'.5rem .3rem',
											minWidth:'0px !important',
											boxSizing:'content-box',
											fontSize: 'var(--bs-body-font-size);',
											color:'var(--bs-body-color)',
											'&:last-child':{paddingRight:'1rem'}
										}
									},
									rows:{
										style: {
											minHeight:"0",
										},
										selectedHighlightStyle:{
											backgroundColor:'red'
										}
									}
								}}
								onRowMouseEnter={this.highlightOnMap}
								onRowMouseLeave={this.deHighlightOnMap}
								onRowClicked={this.handleRowClick }
								selectableRowSelected={r=>this.isSelectedOnList(r)}
								highlightOnHover
								selectableRowsHighlight
								pointerOnHover
								sortIcon={<i className="ri-expand-up-down-line" />}
								noDataComponent={

									<Row className="p-0 py-3 m-0">

										<Col xs="1 pe-0">
											<Info className="text-danger" size={15} />
										</Col>
										<Col xs="11 ps-0">
											<b>Please note:</b> There are currently no annotations placed in this scenario.
										</Col>



									</Row>
								}
							/>
							{this.selected && !!this.selected.length &&
								<Row className="p-3 batch-action">
									<Col xs="6">
										{this.selected.length} Items selected
									</Col>
									<Col xs="6 text-end">
										<Button variant="primary" onClick={this.handleBulkDelete}>Delete</Button>
									</Col>
								</Row>
							}
						</div>

					</div>

				</div>	
				<Container>
					<Row className="status-switch">	
						<Col xs="12">
							<Form.Check id={"expand-all"} value="1" onClick={this.handleExpandAll} type="switch" defaultChecked={false} /> Expand all annotations
						</Col>
					</Row>
				</Container>
			</>
		);
		
	}
}

export default ToolAnnotation;